<div class="container ps-0">
  <div class="d-flex justify-content-between align-items-center pb-4">

    <app-logo-display [logoHeuresInsertionUrl]="logoHeuresInsertionUrl"></app-logo-display>

    <app-chantier-selector *ngIf="selectedChantier" [selectableChantiers]="selectableUserChantiers"
                           [selectedChantier]="selectedChantier"
                           (chantierSelected)="onChantierSelected($event)"/>

    <div class="d-flex right-section align-items-center">
      <app-user-widget [user]="connectedUser" (logout)="logOut()" class="pe-0"/>
    </div>
  </div>
</div>



